import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CookieService } from '../services/cookie-service/cookie.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private isRefreshing = false;

    constructor(
        private cookieService: CookieService,
        private router: Router
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // withCredentials: true est nécessaire pour que le navigateur transmette le cookie
        // HttpOnly ptr_auth_token sur chaque requête vers l'API.
        // Le cookie est envoyé automatiquement — plus besoin d'injecter Authorization: Bearer.
        const reqWithCredentials = request.clone({ withCredentials: true });

        return next.handle(reqWithCredentials).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && !this.isRefreshing) {
                    this.isRefreshing = true;
                    this.cookieService.removeCookies();
                    this.router.navigate(['/login']).then(() => {
                        this.isRefreshing = false;
                    });
                }

                return throwError(() => error);
            })
        );
    }
}